import COMMON_FIELDS from "src/general/constants/commonFields";

export enum LOCALSTORAGE_METHODS {
	SET = "SET",
	GET = "GET",
	REMOVE = "REMOVE",
}

export interface ILocalStorageParams {
	[COMMON_FIELDS.KEY]: string;
	[COMMON_FIELDS.DATA]?: string;
}

export const localStorageService = (
	method: LOCALSTORAGE_METHODS,
	{ key, data }: ILocalStorageParams
) => {
	switch (method) {
		case LOCALSTORAGE_METHODS.GET:
			return localStorage.getItem(key);
		case LOCALSTORAGE_METHODS.REMOVE:
			localStorage.removeItem(key);
			break;
		case LOCALSTORAGE_METHODS.SET:
			if (typeof data === "string") {
				localStorage.setItem(key, data);
			}
			break;
	}
};
